import { TFunction, useTranslation } from 'react-i18next';
import { OperationTypes } from 'utils/enums/system-template';
import useOperationType from './use-operation-type';

type UseOperationTranslationResult = {
  t: TFunction;
};

const defaultOperation = import.meta.env.VITE_DEFAULT_OPERATION || 'default';

const useOperationTranslation = (operation?: OperationTypes): UseOperationTranslationResult => {
  const { operationType } = useOperationType();

  return useTranslation(operation ? [operation, defaultOperation] : [operationType, defaultOperation]);
};

export default useOperationTranslation;
